import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose?: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const TermsModal = (props) => {
  const { open, handleClose } = props;

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        disableEscapeKeyDown
      >
        <Typography
          gutterBottom
          color="textSecondary"
          style={{
            paddingLeft: 16,
            paddingTop: 16,
            fontSize: 24,
          }}
        >
          Terms
        </Typography>
        <DialogContent dividers>
          <Typography gutterBottom color="textSecondary">
            Solana AMC is a fully decentralized protocol. No representation or
            warranty is made concerning any aspect of the Solana AMC Protocol,
            including its suitability, quality, availability. The accessibility,
            accuracy, and safety of the protocol have yet to be audited. Access
            to and use of the Solana AMC protocol is entirely at users' own risk
            and could lead to substantial losses. Users take full responsibility
            for their use of the Solana AMC protocol, including participation in
            investment funds and the earning of products, including, without
            limitation, tokens, and coins. The Solana AMC Protocol is not
            available to residents of Belarus, the Central African Republic, the
            Democratic Republic of Congo, the Democratic People's Republic of
            Korea, the Crimea region of Ukraine, Cuba, Iran, Libya, Somalia,
            Sudan, South Sudan, Syria, the USA, Yemen, and Zimbabwe or any other
            jurisdiction in which accessing or using the Solana AMC Protocol is
            prohibited (Prohibited Jurisdiction). In using the protocol, you
            confirm that you are not a citizen of nor reside in a Prohibited
            Jurisdiction. SAMC and SAN tokens are not available to citizens or
            residents of Prohibited Jurisdictions nor can they be transferred to
            citizens or residents of Prohibited Jurisdictions.
          </Typography>
          <Typography gutterBottom color="textSecondary">
            Cookies are used to enhance the services available to you.
          </Typography>
          <Typography gutterBottom color="textSecondary">
            By continuing, you agree to the terms and use of cookies.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
